import React from 'react';
import { Carousel } from '@arco-design/web-react';
import useLocale from '@/utils/useLocale';
import locale from './locale';
import styles from './style/index.module.less';

export default function LoginBanner() {
  const t = useLocale(locale);
  const videoRefs = React.useRef<(HTMLVideoElement | null)[]>([]);

  const data = [
    {
      slogan: t['login.banner.slogan1'],
      subSlogan: t['login.banner.subSlogan1'],
      video:
        'https://vod.v-dk.com/e0ab412542b571f0bfab5017e1e90102/aaba064eca5a4bd1acce7bb7de36bc3d-e07a38c3e18c0adb8818969017f66640-fd-nbv1.mp4',
    },
    {
      slogan: t['login.banner.slogan2'],
      subSlogan: t['login.banner.subSlogan2'],
      video:
        'https://vod.v-dk.com/b0ae2d2542b571f092864531958d0102/f5bdaea300a5483f924394157ba46188-edd8efc0d682a25684f31cc0c29935c7-fd-nbv1.mp4',
    },
    {
      slogan: t['login.banner.slogan3'],
      subSlogan: t['login.banner.subSlogan3'],
      video:
        'https://vod.v-dk.com/f0d92b2542b571f0bfa95017f0f80102/0f798e3e34394c61abff8b4dac6993ca-6ef5226559dc9e368717872c6312de81-fd-nbv1.mp4',
    },
  ];

  // 处理轮播切换，重置视频播放
  const handleChange = (currentIndex: number) => {
    // 重置当前视频到开始位置并播放
    const currentVideo = videoRefs.current[currentIndex];
    if (currentVideo) {
      currentVideo.currentTime = 0;
      currentVideo.play().catch(() => {
        // 忽略自动播放失败的情况
      });
    }

    // 暂停其他视频
    videoRefs.current.forEach((video, index) => {
      if (video && index !== currentIndex) {
        video.pause();
      }
    });
  };

  return (
    <Carousel
      className={styles.carousel}
      animation="fade"
      autoPlay={{ interval: 8000 }}
      onChange={handleChange}
    >
      {data.map((item, index) => (
        <div key={`${index}`}>
          <div className={styles['carousel-item']}>
            <div className={styles['carousel-title']}>{item.slogan}</div>
            <div className={styles['carousel-sub-title']}>{item.subSlogan}</div>
            <div className={styles['carousel-video-wrapper']}>
              <video
                ref={(el) => {
                  videoRefs.current[index] = el;
                }}
                className={`${styles['carousel-image']} ${styles['carousel-video']}`}
                src={item.video}
                autoPlay={index === 0}
                loop
                muted
                playsInline
              />
            </div>
          </div>
        </div>
      ))}
    </Carousel>
  );
}
